<div class="w-100" [ngClass]="{ 'h-100': isVertical }">
  @if (title) {
  <h3 [ngClass]="{ 'text-center': isVertical }">
    @if (icon) {
    <fa-icon [icon]="icon" class="mr-2"></fa-icon>
    }
    <span>{{ title }}</span>
  </h3>
  }
  <atx-scroll-buttons
    [enableScrollButtons]="showScrollButtons"
    [scrollOrientation]="scrollOrientation"
    [offsetHeightMargin]="offsetHeightMargin"
    [ngClass]="{ 'h-100 d-block': isVertical }"
  >
    <atx-infinite-scroll
      class="scrollable-sub-container d-flex no-scrollbar"
      [atxWheelHorizontalScroll]="{
        isDisabled: isVertical || !wheelHorizontalScrollEnabled
      }"
      [ngClass]="{ 'h-100': isVertical }"
    >
      <div class="container-fluid" [ngClass]="{ 'w-auto': !isVertical }">
        <div
          [ngStyle]="{ 'max-height': maxHeightStyle }"
          [ngClass]="{
            'row align-items-center flex-nowrap': isHorizontal
          }"
        >
          <ng-content></ng-content>
        </div>
      </div>
    </atx-infinite-scroll>
  </atx-scroll-buttons>
</div>
